(ns hai.mini-apps.routes
  "Mini-app creation and table"
  (:require
   [hai.mini-apps.edit :as mini-app-edit]
   [hai.mini-apps.table :refer [mini-apps-table]]
   [hai.ui.components.new-design.button :as button]
   [hai.ui.icons :as icons]
   [hai.ui.rf-sugar :refer [>e]]
   [hai.web-app.layout :as layout]
   [hai.web-app.routing :as routing]))

(defn mini-apps-page [_]
  [layout/page
   [layout/breadcrumbs]
   [layout/heading]
   [layout/lead*
    [layout/lead "Browser tools that work alongside you. Open one while you're on any page and capture, summarise or save."]
    [:div.buttons
     [button/dark-small
      {:on-click #(>e [:routing/navigate [:admin-ui/mini-app-create]])
       :text "Create a mini-app"
       :icon [icons/plus]}]]]
   [layout/content
    [mini-apps-table]]])

(defn routes []
  [["/mini-apps"
    {:label "Mini-apps"
     :icon icons/outlined-apps
     ::routing/window-title "Mini-apps"}
    [""
     {:name :admin-ui/mini-apps
      :view mini-apps-page}]
    ["/new"
     {:name :admin-ui/mini-app-create
      :breadcrumbs [:admin-ui/mini-apps]
      ::routing/window-title "New Mini-app"
      :view mini-app-edit/create-page
      :controllers [{:start (fn []
                              (>e [::mini-app-edit/load-connections]))}]}]
    ["/edit/{mini-app/uuid}"
     {:name :admin-ui/mini-app-edit
      :breadcrumbs [:admin-ui/mini-apps]
      ::routing/window-title "Edit Mini-app"
      :view mini-app-edit/page
      :controllers [{:parameters {:path [:mini-app/uuid]}
                     :start (fn [{mini-app :path}]
                              (>e [:entity/resolve mini-app
                                   {:request-id [::mini-app-edit/load
                                                 (:mini-app/uuid mini-app)]
                                    :on-success-fx [[:dispatch [::mini-app-edit/load-connections]]
                                                    [:dispatch [::mini-app-edit/on-entity-loaded
                                                                (:mini-app/uuid mini-app)]]]}]))}]}]]])
